import { Link } from "react-router-dom";
import type { MediaItem } from "@/mocks/media";
import { TYPE_LABELS } from "@/mocks/media";

const TYPE_STYLES: Record<MediaItem["type"], string> = {
  movie: "bg-primary-100 text-primary-700",
  series: "bg-secondary-100 text-secondary-700",
  variety: "bg-accent-100 text-accent-700",
};

export default function MediaCard({ item }: { item: MediaItem }) {
  return (
    <Link to={`/detail/${item.id}`} className="group block">
      <div className="relative aspect-[2/3] w-full overflow-hidden rounded-lg bg-background-200">
        <img
          src={item.cover}
          alt={`${item.title} 海报`}
          title={`${item.title} - WWW.17C`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute inset-0 bg-gradient-to-t from-primary-950/70 via-transparent to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100"></span>
        <span className={`absolute left-2 top-2 rounded-md px-2 py-0.5 text-xs font-medium ${TYPE_STYLES[item.type]}`}>
          {TYPE_LABELS[item.type]}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-0.5 rounded-md bg-accent-500 px-2 py-0.5 text-xs font-semibold text-primary-950">
          <i className="ri-star-fill text-[10px]"></i>
          {item.rating.toFixed(1)}
        </span>
      </div>
      <div className="mt-2.5">
        <h3 className="truncate font-heading text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
          {item.title}
        </h3>
        <p className="mt-1 truncate text-xs text-foreground-500">
          {item.year} · {item.region} · {item.genres.slice(0, 2).join(" / ")}
        </p>
      </div>
    </Link>
  );
}